import { render, staticRenderFns } from "./spotWallet.vue?vue&type=template&id=6d1afee2&"
import script from "./spotWallet.vue?vue&type=script&lang=js&"
export * from "./spotWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports